// Generated by CoffeeScript 2.7.0
var Admin__FormsController;

import MessageCards from '../concerns/message_cards.js';

import MessageNavActions from './concerns/message_nav_actions.js';

import ToggleNavMenuAction from '../toggle_nav_menu_action.js';

import Form from 'trunks/vue/admin/compositions/formables/form.js';

import LogicForm from 'trunks/vue/admin/compositions/logic_form.js';

import ResponsesReport from 'trunks/vue/admin/compositions/formables/report.js';

export default Admin__FormsController = (function() {
  class Admin__FormsController extends Skylark.App.BaseController {
    new() {
      var form;
      form = new Skylark.App.Model.Form({
        title: '未命名表单',
        description: '',
        fields: [],
        attachments: []
      });
      this._initEditMessageView(form);
      return document.body.proxy('click', '.js_save_message', () => {
        return this._messageVm.afterValidate('publish', this._messageVm.openSaveConfirm);
      });
    }

    show() {
      this.__toggleNavMenu();
      this.messageType = 'form';
      this._prepareCards();
      return this._updateResponsesCard();
    }

    clone() {
      var form;
      form = new Skylark.App.Model.Form(this.getVars('form'));
      this._initEditMessageView(form);
      return document.body.proxy('click', '.js_save_message', () => {
        if (form.status === 'published') {
          return this._messageVm.afterValidate('save', this._messageVm.updateFields);
        } else {
          return this._messageVm.openSaveConfirm();
        }
      });
    }

    edit() {
      var form;
      this.__toggleNavMenu();
      form = new Skylark.App.Model.Form(this.getVars('form'));
      this._initEditMessageView(form);
      return document.body.proxy('click', '.js_save_message', () => {
        if (form.status === 'published') {
          return this._messageVm.afterValidate('save', this._messageVm.updateFields);
        } else {
          return this._messageVm.openSaveConfirm();
        }
      });
    }

    logic_settings() {
      var el, form, logic_form_view;
      this.__toggleNavMenu();
      form = new Skylark.App.Model.Form(this.getVars('form'));
      el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('logic_form');
      logic_form_view = new LogicForm({
        el: el,
        propsData: {
          formable: form
        }
      });
      return document.body.proxy('click', '.js_save_logic_settings', function() {
        return logic_form_view.save();
      });
    }

    report() {
      var el, messageGID, report_view;
      this.__toggleNavMenu();
      messageGID = new Skylark.Libs.GlobalID(this.getVars().messageGID);
      el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('report_show');
      return report_view = new ResponsesReport({
        el: el,
        propsData: {
          messageGID: messageGID
        }
      });
    }

    _initEditMessageView(form) {
      this.__generateFormView(form);
      document.body.proxy('click', '.js_save_as_draft', () => {
        return this._messageVm.saveAsDraft();
      });
      return document.body.proxy('click', '.js_preview', () => {
        return this._messageVm.preview();
      });
    }

    __generateFormView(form) {
      var el;
      el = Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('message_edit');
      return this._messageVm = new Form({
        el: el,
        data: {
          form: form
        }
      });
    }

  };

  Admin__FormsController.include(MessageCards, MessageNavActions, ToggleNavMenuAction);

  return Admin__FormsController;

}).call(this);
